import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from './assets/linkedin.png'
import _imports_1 from './assets/twitter.svg'
import _imports_2 from './assets/facebook.svg'
import _imports_3 from './assets/vimeo.svg'


const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-3 col-12" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "address" }, [
  /*#__PURE__*/_createTextVNode("McLaren Applied"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Dukes Court, Block E"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Duke Street"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Woking"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" GU21 5BH"),
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "Company number 02322992", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "tel:+44 1483 966 800",
    style: {"text-decoration":"none","color":"#fff"}
  }, "+44 (0)1483 966 800")
], -1)
const _hoisted_7 = { class: "footer-menu contact" }
const _hoisted_8 = { class: "navbar-nav" }
const _hoisted_9 = ["href", "onClick"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "link-container" }, " Contact ", -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "col-md-8 offset-md-1 col-12 offset-0" }
const _hoisted_13 = /*#__PURE__*/_createStaticVNode("<div class=\"row social d-flex flex-row\"><a href=\"https://www.linkedin.com/company/mclaren_applied\" target=\"_blank\"><img width=\"635\" height=\"540\" src=\"" + _imports_0 + "\" alt=\"LinkedIn\"></a><a href=\"https://twitter.com/McLarenApplied\" target=\"_blank\"><img width=\"186\" height=\"150\" src=\"" + _imports_1 + "\" alt=\"Twitter\"></a><a href=\"https://www.facebook.com/mclarenapplied/\" target=\"_blank\"><img width=\"151\" height=\"150\" src=\"" + _imports_2 + "\" alt=\"Facebook\"></a><a href=\"https://vimeo.com/mclarenapplied\" target=\"_blank\"><img width=\"150\" height=\"150\" src=\"" + _imports_3 + "\" alt=\"Viemo\"></a></div>", 1)
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "row text-left" }
const _hoisted_16 = { class: "col-md-3 col-12" }
const _hoisted_17 = { class: "address" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Cookie policy and management")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_FooterSecondaryMenu = _resolveComponent("FooterSecondaryMenu")!
  const _component_FooterMenu = _resolveComponent("FooterMenu")!

  return (_openBlock(), _createElementBlock("footer", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _hoisted_5,
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("ul", _hoisted_8, [
              _createElementVNode("li", null, [
                (_ctx.menuLoaded)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: { name: 'Contact'},
                      custom: ""
                    }, {
                      default: _withCtx(({ href, navigate }) => [
                        _createElementVNode("a", {
                          href: href,
                          onClick: navigate
                        }, _hoisted_11, 8, _hoisted_9)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_FooterSecondaryMenu, { showSecondaryMenu: _ctx.showSecondaryMenu }, null, 8, ["showSecondaryMenu"])
        ])
      ]),
      _hoisted_13,
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_FooterMenu)
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("p", _hoisted_17, [
            _createVNode(_component_router_link, {
              to: "/cookies",
              style: {"color":"#FFF"}
            }, {
              default: _withCtx(() => [
                _hoisted_18
              ]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ]))
}